<div
    class="sidebar-container d-flex flex-row"
    state-sidebar
    sidebar-swipe
    [ngClass]="{ collapsed: state === 1, expanded: state === 0 }"
    (resized)="onResized($event)"
    (mouseover)="isToggled ? setOnHover(true) : ''"
    (mouseout)="isToggled ? setOnHover(false) : ''"
>
    <div class="content">
        <app-menu-option-group></app-menu-option-group>
    </div>
</div>
